import ChartTemplate from "@/components/chart-template";
import { RevenueRow } from "@/http/api-types";
import { calculateCPIAchievement } from "../performance-calculations";
import CPIAchievementChart from "./cpi-chart";

type ChartRow = RevenueRow & {
  dateTime: string;
};

export type ChartData = ChartRow[];

export const revenuePercentagePerRow = (revenue: number, maxRevenue: number) =>
  Math.round((revenue / maxRevenue) * 100);

type CPIChartProps = {
  data: RevenueRow[];
};

function CPIAchievement({ data }: CPIChartProps) {
  const chartData: ChartData = data.map(row => ({
    ...row,
    dateTime: row.bid_day.slice(0, 10),
  }));

  const cpiAchievement = calculateCPIAchievement(data);

  return (
    <ChartTemplate
      chart={<CPIAchievementChart chartData={chartData} />}
      table={null}
      title="CPI Achievement"
      description="Revenue over AP Conversions"
      summaryMetric={cpiAchievement.toLocaleString("en-US", {
        style: "percent",
      })}
      summaryMetricLabel="CPI Achievement"
      timeSplittable={false}
    />
  );
}

export default CPIAchievement;
